<template>
  <div class="map-query-content">
    <!-- 搜索区域 -->
    <div class="query-container">
      <div class="search-box">
        <div class="layui-form-item">
          <div class="layui-input-wrap">
            <div class="layui-input-prefix">
              <i class="layui-icon layui-icon-search"></i>
            </div>
            <input
                type="text"
                v-model="searchQuery"
                placeholder="输入地图名称..."
                class="layui-input"
                lay-affix="clear"
            >
          </div>
        </div>
      </div>
      <div></div> <!-- 占位 -->
    </div>

    <!-- 内容容器：横向排列4个列表区域 -->
    <div class="data-container">
      <!-- 1. 地图列表区域 -->
      <div class="map-list-section">
        <div class="section-header">
          <div v-if="!selectedMap">请选择要查询的地图</div>
          <div v-else>
            已选择
            <span class="highlight-text">{{ selectedMap.name }}</span>&nbsp;地图
          </div>
        </div>
        <div class="section-content">
          <div class="map-list" v-if="filteredMaps.length">
            <div
                v-for="(map, index) in filteredMaps"
                :key="`map-${map.code}-${index}`"
                @click="selectMap(map)"
                :class="{ active: selectedMap && selectedMap.code === map.code }"
            >
              <span style="color:red;">{{index+1}}.</span>{{ map.name }}
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="fas fa-map"></i>
            <p>暂无地图数据</p>
          </div>
        </div>
      </div>
      <!-- 2. 地图走法区域 -->
      <div class="map-list-section">
        <div class="section-header">
          <div v-if="!selectedMap">请先选择要查的地图</div>
          <div v-else>
            正在查询<span class="highlight-text">{{ selectedMap.name }}</span>
            的刷怪信息
          </div>
        </div>
        <div class="section-content">
          <div v-if="mapPaths.length">
            <div
                v-for="(pathGroup, index) in mapPaths"
                :key="`path-group-${index}`"
                class="path-group"
            >
              <div class="path-header">
                第{{ index + 1 }}种走法
              </div>
              <div
                  v-for="(path, pIndex) in pathGroup"
                  :key="`path-${path.from}-${pIndex}`"
                  class="path-item"
                  @click="selectPath(path)"
                  :class="{ active: selectedPath && selectedPath.from === path.from && selectedPath.to === path.to }"
              >
                <div class="section-title"><i class="fas fa-sign-out-alt"></i> {{ path.fromName }}</div>
                <p>从坐标 <span class="coord-badge">{{ path.fromKey }}</span> 进入</p>
                <div class="section-title"><i class="fas fa-sign-in-alt"></i> {{ path.toName }}</div>
                <p>到达坐标 <span class="coord-badge">{{ path.toKey }}</span></p>
              </div>
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="layui-icon layui-icon-tips"></i>
            <p v-if="selectedMap">该地图没有路径数据</p>
            <p v-else>请先选择一个地图</p>
          </div>
        </div>
      </div>
      <!-- 3. 刷新怪物区域（只有选择走法后才显示） -->
      <div class="map-list-section">
        <div class="section-header">
          <div v-if="!selectedPath">请先选择要查的怪物</div>
          <div v-else>
            正在查询<span class="highlight-text">{{ selectedPath.toName }}</span>
            的刷新地
          </div>
        </div>
        <div class="section-content">
          <div class="monster-list" v-if="spawnMonsters.length && selectedPath">
            <div
                v-for="(monster, index) in spawnMonsters"
                :key="`spawn-monster-${monster.id}-${index}`"
                @click="selectMonster(monster)"
                :class="{ active: selectedMonster && selectedMonster.id === monster.id }"
            >
              {{ monster.name }}
              <span class="rate-badge">{{ monster.refreshRate }}分钟/只</span>
              <span class="count-badge">{{ monster.count }}只</span>
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="layui-icon layui-icon-tips"></i>
            <p v-if="selectedPath">该路径终点没有刷新怪物数据</p>
            <p v-else>请先选择一条走法</p>
          </div>
        </div>
      </div>

      <!-- 4. 怪物掉落物品列表区域（显示转换后的掉落率文字） -->
      <div class="map-list-section">
        <div class="section-header">
          <div v-if="!selectedMonster">怪物掉落物品</div>
          <div v-else>
            正在查询<span class="highlight-text">{{ selectedMonster.name }}</span>
            的掉落物品
          </div>
        </div>
        <div class="section-content">
          <div class="item-list" v-if="monsterDrops.length && selectedMonster">
            <div class=" row-rl"
                v-for="(item, index) in monsterDrops"
                :key="`monster-drop-${item.id}-${index}`"
            >
              <div ><span style="color:red;">{{index+1}}.</span>{{ item.name }}</div>
              <!-- 显示文字描述 + 原始数值（可选，增强透明度） -->
              <div><span class="drop-rate-badge" :class="`drop-rate-${item.dropRateLevel}`">
                {{ item.dropRateDesc }} <!--({{ item.dropRate }}%)-->
              </span></div>
            </div>
          </div>
          <div class="empty-state" v-else>
            <i class="layui-icon layui-icon-tips"></i>
            <p v-if="selectedMonster">该怪物没有掉落物品数据</p>
            <p v-else>请先选择一个怪物</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';

export default {
  name: 'MapQueryContent',
  components: {},
  props: {
    mapData: { type: Array, required: true, default: () => [] },
    monsterRefresh: { type: Array, required: false, default: () => [] },
    monsterData: { type: Array, required: false, default: () => [] },
    stditemsData: { type: Array, required: false, default: () => [] }
  },
  setup(props) {
    // 状态管理
    const searchQuery = ref('');
    const selectedMap = ref(null);
    const selectedPath = ref(null);
    const selectedMonster = ref(null);

    // 格式化地图数据
    const formattedMaps = computed(() => {
      return props.mapData.map(map => ({
        name: map[0],
        code: map[1],
        paths: map[2] || [],
        hasPaths: (map[2] && map[2].length > 0) || false
      }));
    });

    // 过滤地图列表
    const filteredMaps = computed(() => {
      if (!searchQuery.value) return formattedMaps.value;
      return formattedMaps.value.filter(map =>
          map.name.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    // 解析地图走法
    const mapPaths = computed(() => {
      if (!selectedMap.value) return [];

      const pathGroups = [];
      const mapPathsData = Array.isArray(selectedMap.value.paths) ? selectedMap.value.paths : [];

      mapPathsData.forEach((pathGroup) => {
        const groupPaths = [];
        pathGroup.forEach(path => {
          if (path.from && path.to) {
            const fromCode = String(path.from).toLowerCase();
            const toCode = String(path.to).toLowerCase();
            const fromMap = formattedMaps.value.find(m =>
                String(m.code).toLowerCase() === fromCode
            );
            const toMap = formattedMaps.value.find(m =>
                String(m.code).toLowerCase() === toCode
            );

            if (toMap) {
              groupPaths.push({
                from: path.from,
                fromName: fromMap ? fromMap.name : `未知地图(${path.from})`,
                fromKey: path.fromkey || '未知',
                to: path.to,
                toName: toMap.name,
                toKey: path.tokey || '未知',
                type: path.type
              });
            }
          }
        });

        if (groupPaths.length > 0) {
          pathGroups.push(groupPaths);
        }
      });

      return pathGroups;
    });

    // 获取刷新怪物列表
    const spawnMonsters = computed(() => {
      if (!selectedPath.value) return [];
      const targetMapCode = selectedPath.value.to;

      if (props.monsterRefresh && props.monsterRefresh.length && props.monsterData && props.monsterData.length) {
        const monsterIds = new Map();

        props.monsterRefresh.forEach(refresh => {
          if (refresh.c_refresh && Array.isArray(refresh.c_refresh)) {
            refresh.c_refresh.forEach(refreshInfo => {
              // 地图编码大小写兼容
              if (String(refreshInfo[0]).toLowerCase() === String(targetMapCode).toLowerCase()) {
                const monsterId = Number(refresh.c_mongen_id);
                const refreshTime = refreshInfo[2] || '未知';
                const count = refreshInfo[1] || 1;
                if (!monsterIds.has(monsterId)) {
                  monsterIds.set(monsterId, {
                    refreshRate: refreshTime,
                    count: count
                  });
                }
              }
            });
          }
        });

        return props.monsterData
            .filter(monster => monsterIds.has(monster[1]))
            .map(monster => ({
              id: monster[1],
              name: monster[0],
              refreshRate: monsterIds.get(monster[1]).refreshRate,
              count: monsterIds.get(monster[1]).count
            }));
      }
      return [];
    });

    // 核心修复：掉落率区间映射 + 文字描述转换
    const monsterDrops = computed(() => {
      if (!selectedMonster.value) return [];
      if (!props.monsterRefresh || !props.monsterRefresh.length) return [];
      if (!props.stditemsData || !props.stditemsData.length) return [];

      // 1. 定义掉落率区间规则（顺序不可乱，从低到高匹配）
      const dropRateRules = [
        { min: 1, max: 299, desc: '很高', level: 'very-high' },
        { min: 300, max: 799, desc: '高', level: 'high' },
        { min: 800, max: 1599, desc: '较高', level: 'medium-high' },
        { min: 1600, max: 2999, desc: '适合', level: 'suitable' },
        { min: 3000, max: 4999, desc: '一般', level: 'normal' },
        { min: 5000, max: 7999, desc: '有点低', level: 'low-medium' },
        { min: 8000, max: Infinity, desc: '低', level: 'low' }
      ];

      // 2. 获取选中怪物的ID（统一数字类型）
      const targetMonsterId = Number(selectedMonster.value.id);
      // 3. 找到该怪物的刷怪数据
      const targetMonsterRefresh = props.monsterRefresh.find(refresh =>
          Number(refresh.c_mongen_id) === targetMonsterId
      );

      if (!targetMonsterRefresh || !targetMonsterRefresh.c_goods || !targetMonsterRefresh.c_goods.length) {
        return [];
      }

      // 4. 解析掉落物品，匹配区间描述
      return targetMonsterRefresh.c_goods.map(goodsItem => {
        // 原始数据：[掉落率数值, 物品ID]
        const [dropRate, itemId] = goodsItem;
        const targetItemId = Number(itemId);
        // 匹配物品名称
        const matchedItem = props.stditemsData.find(item => {
          if (!Array.isArray(item) || item.length < 2) return false;
          return Number(item[1]) === targetItemId;
        });

        // 5. 根据掉落率数值匹配区间描述
        const matchedRule = dropRateRules.find(rule =>
            dropRate >= rule.min && dropRate <= rule.max
        ) || dropRateRules[dropRateRules.length - 1]; // 兜底：默认“低”

        return {
          id: targetItemId,
          name: matchedItem ? matchedItem[0] : `未知物品(${targetItemId})`,
          dropRate: dropRate || 0, // 原始数值（用于显示和区间匹配）
          dropRateDesc: matchedRule.desc, // 转换后的文字描述（如“很高”）
          dropRateLevel: matchedRule.level // 层级标识（用于自定义样式）
        };
      });
    });

    // 选择事件
    const selectMap = (map) => {
      selectedMap.value = map;
      selectedPath.value = null;
      selectedMonster.value = null;
    };

    const selectPath = (path) => {
      selectedPath.value = path;
      selectedMonster.value = null;
    };

    const selectMonster = (monster) => {
      selectedMonster.value = monster;
    };

    return {
      searchQuery,
      selectedMap,
      selectedPath,
      selectedMonster,
      filteredMaps,
      mapPaths,
      spawnMonsters,
      monsterDrops,
      selectMap,
      selectPath,
      selectMonster
    };
  }
};
</script>

<!-- 可选：添加掉落率文字样式（根据level区分颜色，增强视觉体验） -->

<style>
.drop-rate-badge {
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
}
/* 不同掉落率层级的颜色 */
.drop-rate-very-high { background-color: #4cd964; } /* 很高：绿色 */
.drop-rate-high { background-color: #5ac8fa; } /* 高：浅蓝色 */
.drop-rate-medium-high { background-color: #ffcc00; } /* 较高：黄色 */
.drop-rate-suitable { background-color: #ff9500; } /* 适合：橙色 */
.drop-rate-normal { background-color: #ff6b6b; } /* 一般：浅红色 */
.drop-rate-low-medium { background-color: #a77dc2; } /* 有点低：紫色 */
.drop-rate-low { background-color: #999; } /* 低：灰色 */
/* 地图查询组件完整样式表 */
.map-query-content {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0;
  position: relative;
  height: calc(100vh - 100px);
}

/* 搜索区域样式 */
.query-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.search-box {
  background: white;
  border-radius: 4px;
  margin-bottom: 15px;

}

.search-box .layui-form-item {
  margin: 0;
}

.search-box .layui-input {
  border-radius: 4px;
  height: 30px;
  border: 1px solid #e6e6e6;
}

.search-box .layui-input-prefix {
  color: #888;
  line-height: 30px;
}

/* 内容容器样式 */
.data-container {
  display: flex;
  gap: 15px;
  height: calc(100vh - 120px);
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
}

.data-container::-webkit-scrollbar {
  display: none;
}

/* 列表区域样式 */
.map-list-section {
  flex: 0 0 320px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* 列表标题栏样式 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e6e6e6;
  height: 42px;
  box-sizing: border-box;
}

.section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.highlight-text {
  color: #409eff;
  font-weight: 600;
  margin: 0 4px;
}

.section-header .badge {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: #e3f2fd;
  color: #1565c0;
}

/* 列表内容区域样式 */
.section-content {
  flex: 1;
  padding: 15px;
  box-sizing: border-box;
  overflow-y: auto;
  scrollbar-width: none;
}

.section-content::-webkit-scrollbar {
  width: 0;
}

.section-content:hover::-webkit-scrollbar {
  width: 2px;
}

.section-content::-webkit-scrollbar-thumb {
  background-color: rgba(156, 156, 156, 0.6);
  border-radius: 10px;
}

/* 列表项样式 */
.map-list, .monster-list, .item-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.map-list div, .monster-list div, .item-list div {
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: 30px;
  line-height: 30px;
  padding: 0 15px;
  font-size: 14px;
}

.map-list li:hover, .monster-list li:hover, .item-list li:hover {
  background-color: #f0f7ff;
}

.map-list li.active, .monster-list li.active, .item-list li.active {
  background-color: #e3f2fd;
  color: #1565c0;
  font-weight: bold;
}

/* 路径走法项样式（新增选中效果） */
.path-item {
  border-bottom: 1px solid #eee;
  background: #f9f9f9;
  cursor: pointer;  /* 显示可点击光标 */
  transition: all 0.2s ease;
}

.path-item:hover {
  background-color: #f0f7ff;
}

.path-item.active {  /* 走法选中样式 */
  background-color: #e3f2fd;
  border-left: 3px solid #1890ff;
}

/* 徽章样式 */
.path-badge {
  font-size: 12px;
  padding: 1px 6px;
  border-radius: 8px;
  background-color: #f0f9ff;
  color: #1890ff;
}

.rate-badge {
  font-size: 12px;
  padding: 1px 6px;
  border-radius: 8px;
  background-color: #f0f9ff;
  color: #1890ff;
}

.count-badge {
  font-size: 12px;
  padding: 1px 6px;
  border-radius: 8px;
  background-color: #f5f5f5;
  color: #666;
}

.drop-rate-badge {
  font-size: 12px;
  padding: 1px 6px;
  border-radius: 8px;
  background-color: #fff7e6;
  color: #fa8c16;
}

.coord-badge {
  border-radius: 4px;
  background-color: #f0f9ff;
  color: #1890ff;
  font-size: 12px;
}

/* 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  gap: 10px;
}

.empty-state i {
  font-size: 48px;
  opacity: 0.5;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

/* 路径走法样式 */
.path-group {
  margin-bottom: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.path-header {
  padding: 8px 12px;
  background-color: #f5f5f5;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #eee;
}

.section-title {
  font-weight: 500;
  margin-bottom: 4px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 6px;
}

.section-title i {
  color: #1890ff;
}

.path-item p {
  margin: 0 0 8px 0;
  font-size: 13px;
  color: #666;
}

.path-item p:last-child {
  margin-bottom: 0;
}

/* 响应式样式
@media (max-width: 1600px) {
  .map-list-section {
    flex: 0 0 280px;
  }
}

@media (max-width: 1200px) {
  .data-container {
    flex-wrap: wrap;
    height: auto;
    max-height: calc(100vh - 120px);
  }

  .map-list-section {
    flex: 0 0 calc(50% - 10px);
  }
}*/

@media (max-width: 768px) {
  .query-container {
    grid-template-columns: 1fr;
  }

  .data-container {
    flex-direction: column;
  }

  .map-list-section {
    flex: 0 0 300px;
    width: 100%;
  }
}
/* 1. 控制 item-list 内的每行布局（关键） */
.item-list .row-rl {
  display: flex;          /* 启用弹性布局 */
  justify-content: space-between; /* 子元素两端对齐（第一个靠左，第二个靠右） */
  align-items: center;    /* 子元素垂直居中（避免上下错位） */
  width: 100%;            /* 占满父容器宽度（确保两端对齐生效） */
  margin: 6px 0;          /* 上下留间距，优化视觉 */
  padding: 2px 0;         /* 可选：上下内边距，避免内容贴边 */
}

/* 2. 可选：给物品名添加最小宽度，避免短名称导致掉落率过早靠右 */
.item-list .row-rl .item-name {
  flex: 1; /* 让物品名区域占满剩余空间（可选，根据需求调整） */
  /* 或用最小宽度：min-width: 150px; 防止物品名过短时掉落率太靠左 */
}

/* 3. 可选：给掉落率添加右对齐补充（确保极端情况下也靠右） */
.item-list .row-rl .item-drop-rate {
  text-align: right;      /* 文字右对齐（兜底，确保即使Flex失效也靠右） */
  white-space: nowrap;    /* 避免掉落率文字换行（如“有点低”不会拆成两行） */
}

/* 原有掉落率徽章样式保持不变 */
.drop-rate-badge {
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
}
.drop-rate-very-high { background-color: #4cd964; }
.drop-rate-high { background-color: #5ac8fa; }
.drop-rate-medium-high { background-color: #ffcc00; }
.drop-rate-suitable { background-color: #ff9500; }
.drop-rate-normal { background-color: #ff6b6b; }
.drop-rate-low-medium { background-color: #a77dc2; }
.drop-rate-low { background-color: #999; }
</style>
